import React, { createContext, useContext, ReactNode } from 'react';
import { useInventory, InventoryItem, CreateInventoryItemData, Loan } from '../hooks/useInventory';
import { InventoryFolder } from '../services/inventoryFoldersService';

interface InventoryContextValue {
  items: InventoryItem[];
  loading: boolean;
  error: string | null;
  folders: InventoryFolder[];
  foldersLoading: boolean;
  createFolder: (name: string) => Promise<InventoryFolder>;
  renameFolder: (folderId: string, name: string) => Promise<void>;
  deleteFolder: (folderId: string) => Promise<void>;
  refreshFolders: () => Promise<void>;
  createItem: (itemData: CreateInventoryItemData) => Promise<InventoryItem>;
  updateItem: (itemId: string, updates: Partial<CreateInventoryItemData>) => Promise<void>;
  deleteItem: (itemId: string) => Promise<void>;
  setItemLoan: (itemId: string, loan: Loan) => Promise<void>;
  returnItem: (itemId: string, expected?: { loanId?: string; loanedAt?: string; borrowerName?: string }) => Promise<void>;
  getItemById: (itemId: string) => InventoryItem | undefined;
  getItemsByCategory: (category: string) => InventoryItem[];
  searchItems: (searchTerm: string) => InventoryItem[];
  getStats: () => {
    totalItems: number;
    totalValue: number;
    categoriesCount: Record<string, number>;
    categories: string[];
  };
  getAllItems: () => InventoryItem[]; // Adicionar o método
}

const InventoryContext = createContext<InventoryContextValue | undefined>(undefined);

export const InventoryProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const inventory = useInventory();

  return (
    <InventoryContext.Provider value={inventory}>
      {children}
    </InventoryContext.Provider>
  );
};

export const useInventoryContext = () => {
  const context = useContext(InventoryContext);
  if (context === undefined) {
    throw new Error('useInventoryContext deve ser usado dentro de um InventoryProvider');
  }
  return context;
};

export type { InventoryItem, Loan };
export type { InventoryFolder };
